import $ from 'jquery';

export default function BranchSession(vm) {
    this.all = function(params) {
        var url = '/branch-session/list?' + $.param(params);

        return vm.get(url);
    };
}